<template>
  <div class="root">
    <div v-if="step === 4">
      <h1 class="text-center text-uppercase">
        Campaign Preview
      </h1>
    </div>
    <div class="campaign-create-container hh-profile-container margin-top-50" ref="top">
      <div class="">
        <div class="container-fluid" :style="[ (step == 4) ? {'background': 'none'} : {'background' : 'white'}]">

          <div v-if="isLoading" class="section-body margin-top-50 margin-bottom-50">
            <loading-animation :show-message="true" no-bg />
          </div>

          <div v-show="!isLoading" v-if="dataAnalysed">
            <div class="section-body padding-bottom-50" v-if="step < 4">
              <div class="row margin-top-10">
                <div class="col-sm-12">
                  <h1 class="text-left">
                    {{ formTitle }}
                  </h1>
                  <p v-if="step === 1" class="hint-text-edit">
                    Keep in mind that you can edit this information at any time.
                  </p>
                  <p v-if="step === 3" class="hint-text-edit">
                    Enter your social profile URL's so supporters can follow you. For Facebook and Twitter, users can
                    share your campaign to their Facebook or Twitter. Enter below the message you would like their
                    shared post to be pre-populated with.
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="progress-bar-wrapper step-3">
                    <progress-bar
                        :length="3"
                        :step="step"
                    />
                  </div>
                </div>
              </div>

              <div v-show="!isLoading" class="row margin-top-20" v-if="dataAnalysed">
                <div class="col-sm-12">
                  <div class="campaign-information-section" ref="campaignInformation" v-if="step === 1">
                    <campaign-information
                        @componentLoading="componentLoading"
                        @formSubmitted="formSubmitted"
                        :campaignData="campaignData"
                        :staticData="staticData"
                        :campaignImages="campaignImages"
                        @navigateBack="navigateBack"
                        @navigateNext="navigateNext"
                    />
                  </div>


                  <div class="campaign-suggested-donation-amounts-section" ref="campaignSuggestedDonationAmounts"
                       v-if="step === 2">
                    <campaign-suggested-donation-amounts
                        @componentLoading="componentLoading"
                        @formSubmitted="formSubmitted"
                        :campaignData="campaignData"
                        :staticData="staticData"
                        @navigateBack="navigateBack"
                        @navigateNext="navigateNext"
                    />
                  </div>
                  <div class="campaign-social-links" ref="campaignSocialLinks" v-if="step === 3">
                    <campaign-social-links
                        @componentLoading="componentLoading"
                        @formSubmitted="formSubmitted"
                        :campaignData="campaignData"
                        :staticData="staticData"
                        @navigateBack="navigateBack"
                        @navigateNext="navigateNext"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="campaign-preview-section" ref="campaignPreview" v-if="step === 4">
              <campaign-preview
                  @componentLoading="componentLoading"
                  @formSubmitted="formSubmitted"
                  :campaignImages="campaignImages"
                  :campaignData="campaignData"
                  :staticData="staticData"
                  @navigateBack="navigateBack"
              />
            </div>
            <div class="verify-bank-information" ref="verifyBankInformation" v-if="step === 5">
              <verify-bank-information
                  @componentLoading="componentLoading"
                  @formSubmitted="formSubmitted"
                  alias="campaignComponent"
                  :campaignData="campaignData"
                  :userCampaigns="userCampaigns"
                  :staticData="staticData"
                  @navigateBack="navigateBack"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import Alert from '../../components/form/elements/Alert'
import LoadingAnimation from '../../components/LoadingAnimation'
import ProgressBar from '../../components/ProgressBar'
import CampaignInformation from '../../components/campaign/CampaignInformation'
import CampaignDetails from '../../components/campaign/CampaignDetails'
import CampaignSuggestedDonationAmounts from '../../components/campaign/CampaignSuggestedDonationAmounts'
import CampaignSocialLinks from '../../components/campaign/CampaignSocialLinks'
import CampaignPreview from '../../components/campaign/CampaignPreview'
import VerifyBankInformation from '../../components/campaign/VerifyBankInformation'

export default {
  name: 'CreateCampaignView',

  components: {
    CampaignInformation,
    CampaignDetails,
    CampaignSuggestedDonationAmounts,
    CampaignSocialLinks,
    CampaignPreview,
    VerifyBankInformation,
    Alert,
    LoadingAnimation,
    ProgressBar,
  },

  props: {},

  beforeMount() {
    if (!_.isEmpty(this.$route.params.slug)) {
      this.campaignSlug = this.$route.params.slug
    }

    if (!this.isDataFetched) {
      this.fetchData(this.campaignSlug).then(() => {
        this.forceRecompute++
        this.analyseData()
      })
    } else {
      this.analyseData()
    }
  },

  mounted() {
    this.loading = false
  },

  data: () => {
    return {
      campaignSlug: null,
      loading: true,
      dataAnalysed: false,
      step: 1,
      forceRecompute: 0,
      componentsLoadingStatus: {
        campaignComponent: true,
      },
      campaignData: {},
      userCampaigns: {},
      campaignImages: {},
      staticData: {},
    }
  },

  methods: {
    ...mapActions('campaign', ['fetchData']),

    analyseData() {
      this.dataAnalysed = false
      this.loading = true

      if (this.isDataFetched) {
        this.fillCampaignData()
        this.fillUserCampaigns()
        this.fillCampaignImages()
        this.fillStaticData()

        if (!_.isEmpty(this.fetchedData.data.attributes)) {
          this.step = this.fetchedData.data.attributes.creation_step + 1

          if (this.fetchedData.data.attributes.slug != null && this.fetchedData.data.attributes.slug !== this.campaignSlug) {
            this.$router.push(`/campaign/create/${this.fetchedData.data.attributes.slug}`)
          }
        }
      } else {
        return false
      }

      if (this.step > 5) {
        window.location = `/campaign/${this.fetchedData.data.attributes.slug}`
      } else {
        this.dataAnalysed = true
        this.loading = false
      }
    },

    fillCampaignData() {
      if (!_.isEmpty(this.fetchedData.data.attributes)) {
        this.campaignData = {...this.campaignData, ...this.fetchedData.data.attributes}
      }
    },

    fillUserCampaigns() {
      if (!_.isEmpty(this.fetchedData.data.relations.userCampaigns)) {
        this.userCampaigns = {...this.fetchedData.data.relations.userCampaigns}
      }
    },

    fillCampaignImages() {
      if (!_.isEmpty(this.fetchedData.data.relations.campaignImages)) {
        this.campaignImages = {...this.fetchedData.data.relations.campaignImages}
      }
    },

    fillStaticData() {
      if (!_.isEmpty(this.fetchedData.data.staticData)) {
        this.staticData = {...this.staticData, ...this.fetchedData.data.staticData}
      }
    },

    navigateBack() {
      this.componentsLoadingStatus.campaignComponent = true
      --this.step
    },

    navigateNext() {
      this.componentsLoadingStatus.campaignComponent = true
      ++this.step
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value
    },

    formSubmitted() {
      this.loading = true
      this.fetchData(this.campaignSlug).then(() => {
        this.forceRecompute++
        this.analyseData()
      })
    },

    imagesUpdated(images) {
      this.campaignImages = {...images}
    },
  },

  computed: {
    ...mapGetters(['alert']),

    fetchedData: {
      get() {
        return this.$store.getters['campaign/campaignData'](this.campaignSlug, this.forceRecompute)
      },
    },

    formTitle() {
      if (this.isLoading) {
        return 'Loading...'
      }

      if (this.step === 4) {
        return 'Preview Campaign'
      }

      return 'Create Campaign'
    },

    isDataFetched() {
      return !_.isEmpty(this.fetchedData)
    },

    isLoading() {
      for (let component in this.componentsLoadingStatus) {
        if (this.componentsLoadingStatus[component]) {
          return true
        }
      }

      return this.loading
    },
  },
}
</script>

<style lang="scss" scoped>
.root::v-deep {
  @import '../../../style/pages/profile';
  @import '../../../style/pages/campaign';
}

h1 {
  font-family: Circular Std;
  font-style: normal;
  font-weight: bold;
  font-size: 26px !important;
  line-height: 33px !important;
  letter-spacing: -0.01em;
  color: #000000;
}

.hint-text-edit {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 15px;
  color: rgb(174, 174, 174);
}
</style>